class ThemeHeader extends HTMLElement {
  connectedCallback() {
    this.mobileMenu = this.querySelector('[data-mobile-menu]');
    this.mobileMenuSummary = this.mobileMenu?.querySelector(':scope > summary');
    this.handleMenuToggle = () => this.onMenuToggle();
    this.handleMenuKeydown = (event) => this.onMenuKeydown(event);
    this.handleViewportChange = (event) => {
      if (event.matches && this.mobileMenu?.open) this.mobileMenu.open = false;
    };

    if (this.mobileMenu) {
      this.mobileMenu.addEventListener('toggle', this.handleMenuToggle);
      this.addEventListener('keydown', this.handleMenuKeydown);
      this.desktopViewport = window.matchMedia('(min-width: 990px)');
      this.desktopViewport.addEventListener('change', this.handleViewportChange);
      this.onMenuToggle();
    }
  }

  disconnectedCallback() {
    this.mobileMenu?.removeEventListener('toggle', this.handleMenuToggle);
    this.removeEventListener('keydown', this.handleMenuKeydown);
    this.desktopViewport?.removeEventListener('change', this.handleViewportChange);
    document.body.classList.remove('menu-open');
  }

  onMenuToggle() {
    const isOpen = this.mobileMenu?.open === true;
    document.body.classList.toggle('menu-open', isOpen);
    this.mobileMenuSummary?.setAttribute('aria-expanded', String(isOpen));
  }

  onMenuKeydown(event) {
    if (!this.mobileMenu?.open) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.mobileMenu.open = false;
      this.mobileMenuSummary?.focus();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = [
      this.mobileMenuSummary,
      ...this.mobileMenu.querySelectorAll('a[href], summary, button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
    ].filter((element, index, elements) => element && elements.indexOf(element) === index);
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

if (!customElements.get('theme-header')) {
  customElements.define('theme-header', ThemeHeader);
}

document.addEventListener('click', (event) => {
  const wishlistButton = event.target.closest('[data-wishlist-placeholder]');
  if (!wishlistButton) return;

  const status = document.getElementById('ThemeStatus');
  if (status) status.textContent = wishlistButton.dataset.message || '';
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.product-card__form')) return;

  event.preventDefault();

  const button = form.querySelector('[data-quick-add-button]');
  const status = document.getElementById('ThemeStatus');
  if (!button || button.disabled) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  try {
    await window.themeCart.add(form);

    if (status) status.textContent = button.dataset.successMessage || '';
    button.textContent = button.dataset.addedLabel || button.textContent;
    window.setTimeout(() => {
      button.textContent = button.dataset.defaultLabel || button.textContent;
    }, 1600);
  } catch (error) {
    if (status) status.textContent = error.message || button.dataset.errorMessage || '';
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
